import { FC, ReactNode, useMemo } from 'react';
import { KioskTypes } from '../../../../types';
import { KioskFormsContextProps, KioskFormsContext } from './kiosk-forms.context';

interface KioskFormsMainProps extends KioskFormsContextProps {
  children: ReactNode;
}

const ACCEPTED_PATRON_TYPES: Set<KioskTypes.Patron> = new Set(['new', 'existing']);

const KioskFormsMain: FC<KioskFormsMainProps> = ({ children, locationId, patronType }) => {
  const contextValue = useMemo<KioskFormsContextProps>(
    () => ({
      locationId,
      // Ensure patronType is one of the accepted types
      patronType: ACCEPTED_PATRON_TYPES.has(patronType) ? patronType : 'new',
    }),
    [locationId, patronType]
  );

  return <KioskFormsContext.Provider value={contextValue}>{children}</KioskFormsContext.Provider>;
};

export default KioskFormsMain;
